import { render, staticRenderFns } from "./block-inputs.vue?vue&type=template&id=a7502846&scoped=true&"
import script from "./block-inputs.vue?vue&type=script&lang=ts&"
export * from "./block-inputs.vue?vue&type=script&lang=ts&"
import style0 from "./block-inputs.vue?vue&type=style&index=0&id=a7502846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7502846",
  null
  
)

export default component.exports